module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/email-general-icon-9d5180fc61141da0b1c73d2d4cfdef63.svg";